import * as React from 'react';
import { I18n } from 'react-redux-i18n';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../reducers';
import ResourceSelector from '../../containers/ResourceSelector';
import Popup, { FooterData } from '../Popup';
import { changeCoverImage, closeCoverImagePanel } from '../../containers/CoverImagePanel/actions';
import { removeFileFromImport } from '../../containers/ImportManager/actions';
import { getNumberFromString } from '../../containers/Editor/utils/helpers';
import { PopupBodyWrapper } from './styles';
import DriveItemUtils from '../../utils/driveItem';
import { Api } from '../../typings/api';

interface CoverImagePanelProps {
	driveItem: Api.DriveItem;
	isDisplayed: boolean;
	isImportingFile: boolean;
	dispatch: Dispatch<StoreState>;
}

export const importManagerId = 'cover-image';

const isDefaultCover = (driveItem: Api.DriveItem | null): boolean => {
	if (!driveItem) {
		return true;
	}

	const { icon, src } = driveItem;

	return !icon || getNumberFromString(src) === getNumberFromString(icon);
};

const CoverImagePanel = ({
	driveItem,
	isDisplayed,
	isImportingFile,
	dispatch,
}: CoverImagePanelProps) => {
	const popupFooter: FooterData | undefined = isDefaultCover(driveItem) || isImportingFile
		? undefined
		: {
			label: I18n.t('messages.reset_to_default'),
			onAccept: () => dispatch(changeCoverImage(-1)),
		};

	const handleCancelClick = () => {
		if (isImportingFile) {
			dispatch(removeFileFromImport(importManagerId));
		}

		dispatch(closeCoverImagePanel());
	};

	return (
		<Popup
			isDisplayed={isDisplayed}
			label={I18n.t('messages.change_cover_image')}
			footer={popupFooter}
			onCancel={handleCancelClick}
			gallerySlot="coverImagePanel"
		>
			<PopupBodyWrapper hasFooter={!!popupFooter}>
				<ResourceSelector
					id={importManagerId}
					fileExtensions={DriveItemUtils.imageWithGifExtensions}
					isFileExtensionsDisplayed={false}
					isValidResourceFromApp={({ type }) => type === Api.DriveItemType.Image}
					onSelect={([resource]) => dispatch(changeCoverImage(resource.id))}
					isOptimizedImageImport={true}
				/>
			</PopupBodyWrapper>
		</Popup>
	);
};

export default CoverImagePanel;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CoverImagePanel/index.tsx